export enum SmartBgModel {
  SMART_BG_V2_ACCELERATED = 'smartbg-v2-accelerated',
}

export type PipelineParams = {
  task: string;
  params: any;
  version?: string;
  useWorkflowAPI?: boolean;
};

export type WaitTaskParams = Omit<PipelineParams, 'params'> & {
  taskId: string;
  initialTimeout: number;
  isCancel: () => boolean;
  includeSubTasks?: boolean;
  timeout?: number;
};
